let date = new Date();
export default {
    dateType: 1,
    dates: [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ],
    CurrencyId: [],
    RequirementSumFrom: 0,
    RequirementSumTo: 0,
    PayStates: [],

    ContragentID: '',
    ContragentName: '',
    ContragentType: '',
    RegularPaymentTypeId: '',
    AgreementCode: '',
    AccountNumber: '',

    PaymentOperationID: '',
    CategoryId: '',
    PaymentTypeId: '',
    CashId: '',
    PaymentAccountId: '',


    LatePayments: false,
    OnlyAccepted: false,
}